<template>
  <div class="star-condition" v-show="isShow">
    <span class="label" :style="{ width: `${labelWidth}px` }" v-if="label">{{ label }} : </span>
    <div class="star-condition-input">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['addChild', 'removeChild'],
  props: {
    label: {
      type: String
    },
    labelWidth: {
      type: Number,
      default: 95
    }
  },
  data() {
    return {
      isShow: true,
      id: 0
    }
  },
  mounted() {
    this.id = Math.random()
    if (this.addChild) {
      this.addChild({
        hide: this.hide,
        show: this.show,
        id: this.id
      })
    }
  },
  beforeDestroy() {
    if (this.removeChild) {
      this.removeChild(this.id)
    }
  },
  methods: {
    hide() {
      this.isShow = false
    },
    show() {
      this.isShow = true
    }
  }
}
</script>

<style lang="less" scoped>
.star-condition {
  width: 24%;
  min-width: 300px;
  padding-right: 1vw;
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  .label {
    margin-right: 10px;
    text-align: right;
  }

  .star-condition-input {
    flex: 1;
  }

  &.large {
    width: 48%;
  }
}
</style>
